import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import props.
import {
	ComparativeDataSectionProps,
} from '@app/props';

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		comparativeDataSection_container: {
			display: 'flex',
			flexDirection: 'column',
			padding: (props: ComparativeDataSectionProps) => {
				return theme.spacing(
					props.paddingProps?.top !== undefined ? props.paddingProps.top : 1,
					props.paddingProps?.right ?? 0,
					props.paddingProps?.bottom !== undefined ? props.paddingProps.bottom : 1,
					props.paddingProps?.left ?? 0)
			},
		},
		comparativeDataSection_sectionBody: {
			marginLeft: (props: ComparativeDataSectionProps) => theme.spacing(props.indent !== undefined ? props.indent : 2),
			display: 'flex',
			flexDirection: 'column',
		},
	});
});

export default useStyles;
